import httpClient from '@/http-client'

export const bankProfile = (Options = {}) => {
  return httpClient
    .get('/api/v1/payment-vendors/bank-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const stockin = (Options = {}) => {
  return httpClient
    .get('/api/v1/payment-vendors/stock-ins', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/payment-vendors', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/payment-vendors/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/payment-vendors', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/payment-vendors/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = (id, data) => {
  return httpClient
    .put(`/api/v1/payment-vendors/${id}/delete`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const toPdf = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/payment-vendors/${id}/to-pdf`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const purchasInvoice = stock_in_id => {
  return httpClient
    .get(`/api/v1/payment-vendors/purchas-invoices/${stock_in_id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const vendors = (Options = {}) => {
  return httpClient
    .get('/api/v1/payment-vendors/vendors', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const paymentMethod = (Option = {}) => {
  return httpClient
    .get('/api/v1/payment-vendors/payment-methods', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default { get, find, store, update, destroy, stockin, toPdf, bankProfile, purchasInvoice, vendors, paymentMethod }
